import { LocalePrefix } from '@tmh-website/shared/const';

export const AVAILABLE_LOCALES: LocalePrefix[] = Object.values(LocalePrefix).filter(
  locale => locale !== LocalePrefix.FrCH
);

export const ENERGY_LOCALES: LocalePrefix[] = [LocalePrefix.De, LocalePrefix.En, LocalePrefix.Fr];
